import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  RatesViewActions,
  NBGRate,
  CommercialRate,
  AddNBGRateAttributes,
  AddCommercialRateAttributes,
  DeleteNBGRateAttributes,
  DeleteCommercialRateAttributes,
} from '@lk/api'
import { translate as mainTranslate } from 'loankeeper-common/helpers'

import { actions as LKModalActions } from '../../features/shared/LKModal'
import { ThunkApi } from '../index.d'

const translateLKMESSAGE = (key: string) => mainTranslate(`LKMESSAGE-${key}`)
export interface LoadNBGRatesAttributes {
  startDate: string
  endDate: string
  ccy: string
}

export const loadNBGRates = createAsyncThunk<NBGRate[], LoadNBGRatesAttributes, ThunkApi>(
  '[RATES] LOAD_NBG_RATES',
  async ({ startDate, endDate, ccy }, { extra, rejectWithValue }) => {
    const result = await extra.api.rates.get<NBGRate[]>({
      action: RatesViewActions.NBG,
      StartDate: startDate,
      EndDate: endDate,
      CCY: ccy,
    })

    if (result.success) {
      return result.data
    }

    return rejectWithValue('Failed to load NBG rates')
  },
)

export interface LoadCommercialRatesAttributes {
  startDate: string
  endDate: string
  ccy: string
  ccy2: string
  nodeId: number
  typeId: number
}

export const loadCommercialRates = createAsyncThunk<CommercialRate[], LoadCommercialRatesAttributes, ThunkApi>(
  '[RATES] LOAD_COMMERCIAL_RATES',
  async ({ startDate, endDate, ccy, ccy2, nodeId, typeId }, { extra, rejectWithValue }) => {
    const result = await extra.api.rates.get<CommercialRate[]>({
      action: RatesViewActions.Commercial,
      StartDate: startDate,
      EndDate: endDate,
      CCY: ccy,
      CCY2: ccy2,
      NodeID: nodeId,
      TypeID: typeId,
    })

    if (result.success) {
      return result.data
    }

    return rejectWithValue('Failed to load Commercial rates')
  },
)

export const loadRateLimits = createAsyncThunk<any, void, ThunkApi>(
  '[RATES] LOAD_RATE_LIMITS',
  async (_, { dispatch, extra, rejectWithValue }) => {
    const result = await extra.api.rates.get({
      action: RatesViewActions.Limits,
    })

    if (result.success) {
      return result.data
    }

    dispatch(LKModalActions.openError(result.error.message))

    return rejectWithValue('Failed to load rate limits')
  },
)

export const getOrderRate = createAsyncThunk<any, { OperTypeID: number; NodeID: number }, ThunkApi>(
  '[RATES] RATES_VIEW_LIVE',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.rates.get({
      action: RatesViewActions.Live,
      OperTypeID: params.OperTypeID,
      NodeID: params.NodeID,
    })

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const addNBGRate = createAsyncThunk<void, AddNBGRateAttributes, ThunkApi>(
  '[RATES] ADD_NBG_RATE',
  async (attributes, { dispatch, extra, rejectWithValue }) => {
    const result = await extra.api.rates.addNBGRate(attributes)

    if (result.success) {
      return
    }

    dispatch(LKModalActions.openError(translateLKMESSAGE(result.error.message)))

    return rejectWithValue('Failed to add NBG rate limits')
  },
)

export const deleteNBGRate = createAsyncThunk<void, DeleteNBGRateAttributes, ThunkApi>(
  '[RATES] DELETE_NBG_RATE',
  async (attributes, { dispatch, extra, rejectWithValue }) => {
    const result = await extra.api.rates.deleteNBGRate(attributes)

    if (result.success) {
      return
    }

    dispatch(LKModalActions.openError(result.error.message))

    return rejectWithValue('Failed to delete NBG rate limits')
  },
)

export const addCommercialRate = createAsyncThunk<void, AddCommercialRateAttributes, ThunkApi>(
  '[RATES] ADD_COMMERCIAL_RATE',
  async (attributes, { dispatch, extra, rejectWithValue }) => {
    const result = await extra.api.rates.addCommercialRate(attributes)

    if (result.success) {
      return
    }

    dispatch(LKModalActions.openError(result.error.message))

    return rejectWithValue('Failed to add Commercial rate limits')
  },
)

export const deleteCommercialRate = createAsyncThunk<void, DeleteCommercialRateAttributes, ThunkApi>(
  '[RATES] DELETE_COMMERCIAL_RATE',
  async (attributes, { dispatch, extra, rejectWithValue }) => {
    const result = await extra.api.rates.deleteCommercialRate(attributes)

    if (result.success) {
      return
    }

    dispatch(LKModalActions.openError(result.error.message))

    return rejectWithValue('Failed to delete Commercial rate limits')
  },
)
